import $ from 'jquery';

class ModalHandler {
    constructor() {
        this.$infoButton = $('.vjs-share-link.info');
        this.infoTitle = this.$infoButton.data('title');
        this.infoDescription = this.$infoButton.data('description');
        this.$shareButton = $('.vjs-share-link.share');
        this.shareFacebook = this.$shareButton.data('facebook');
        this.shareTwitter = this.$shareButton.data('twitter');
        this.shareLinkedin = this.$shareButton.data('linkedin');
        this.shareURL = this.$shareButton.data('share-url');
        this.$embedButton = $('.vjs-share-link.embed');
        this.embedURL = this.$embedButton.data('url').replace('http:', '') + '?rel=1&src=embed&veggiemode=1';
        this.player = window.player;
    }

    infoClickHandler() {
        let infoModal = this.player.createModal();
        infoModal.addClass('info-modal');
        $('.info-modal').append(
            '<div class="modal-container info-container">' +
                '<h1>' + this.infoTitle + '</h1>' +
                this.infoDescription +
            '</div>'
        );
    }

    shareClickHandler() {
        let shareEmail = 'mailto:?body=' + encodeURIComponent(this.shareURL) + '&subject=' + encodeURIComponent(this.infoTitle);
        let shareModal = this.player.createModal();
        shareModal.addClass('share-modal');
        $('.share-modal').append(
            '<div class="modal-container share-container">' +
                '<h2>Share</h2>' +
                '<textarea>' +
                    this.shareURL +
                '</textarea>' +
                '<a target="_blank" data-event-category="Social" data-event-action="Share:Facebook" class="facebook-link" href="' + this.shareFacebook + '">' +
                    '<i class="icon-facebook"></i>' +
                '</a>' +
                '<a target="_blank" data-event-category="Social" data-event-action="Share:Twitter"  class="twitter-link" href="' + this.shareTwitter + '">' +
                    '<i class="icon-twitter"></i>' +
                '</a>' +
                '<a target="_blank" data-event-category="Social" data-event-action="Share:Linkedin"  class="linkedin-link" href="' + this.shareLinkedin + '">' +
                    '<i class="icon-linkedin"></i>' +
                '</a>' +
                '<a target="_blank"  data-event-category="Social" data-event-action="Share:Email" class="email-link" href="' + shareEmail + '">' +
                    '<i class="icon-share-email"></i>' +
                '</a>' +
            '</div>'
        );
    }

    embedClickHandler() {
        let embedString = '<iframe width="720" height="415" src="' + this.embedURL +
                            '" frameborder="0" scrolling="no" allowfullscreen></iframe>';
        let embedModal = this.player.createModal();
        embedModal.addClass('embed-modal');
        $('.embed-modal').append(
            '<div class="modal-container embed-container">' +
                '<h2>Embed Code: </h2>' +
                '<textarea>' +
                embedString +
                '</textarea>' +
            '</div>'
        );

        document.querySelector('.embed-modal textarea').select();
    }

    // Set Listeners
    on() {
        this.$infoButton.on('click', this.infoClickHandler.bind(this));
        this.$shareButton.on('click', this.shareClickHandler.bind(this));
        this.$embedButton.on('click', this.embedClickHandler.bind(this));
    }
}

export default new ModalHandler();
